/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import Vue from 'vue'

import { FETCH_ORDER_TYPES } from '../../actions.type'
import {
  SET_ORDER_TYPE_ALL_REQUEST,
  SET_ORDER_TYPE_ALL_VALUE,
  UPDATE_ORDER_TYPE
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  orderTypeAllValue: (state) => state.all.value,
  orderTypeAllRequest: (state) => state.all.request,
  orderTypeAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_ORDER_TYPES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('order-type', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_ORDER_TYPE_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_ORDER_TYPE_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_ORDER_TYPE_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_ORDER_TYPE_ALL_VALUE, data)
    } catch (e) {
      commit(SET_ORDER_TYPE_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_UPDATE_ORDER_TYPE({ commit }, value) {
    commit(UPDATE_ORDER_TYPE, value)
  }
}

const mutations = {
  [SET_ORDER_TYPE_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_ORDER_TYPE_ALL_VALUE](state, orderTypes) {
    state.all.value = orderTypes
  },
  [UPDATE_ORDER_TYPE](state, updatedOrderType) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedOrderType.id }),
      1,
      updatedOrderType
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
